import {
	APRECOM_SITE_LIST_DETAILS,
	APRECOM_SITE_LIST_ERROR,
	APRECOM_SITE_LIST_LOADING,
} from '../../constants/graphConstants/connectedClientsGraphConstants';

/**
 * Reducer function for managing hiSenese graph .
 *
 * @param {object} state - Current state of the user login.
 * @param {object} action - Action object that contains information about the action type and payload.
 * @return {object} - New state after applying the action.
 */
export const aprecomSiteListReducer = (
	state = {
		loading: false,
		siteList: [],
		siteError : null
	},
	action
) => {
	switch (action.type) {
		case APRECOM_SITE_LIST_DETAILS:
			return {
				...state,
				loading: false,
				siteError: null,
				siteList: action.payload,
			};
		case APRECOM_SITE_LIST_ERROR:
			return {
				...state,
				loading: false,
				siteList: [],
				...action.payload,
			};
		case APRECOM_SITE_LIST_LOADING:
			return {
				loading: true,
				siteList: action.payload,
				siteError: null,
			};

		default:
			return state;
	}
};
